import React from 'react'

import { PhotoTableCellContent } from '@components/common/PhotoTableCellContent'
import { TableCell } from '@components/common/TableCell'
import type { TableHeaders } from '@fourthwall/components'
import type { GiveawayPackage } from '@fourthwall/services/dist/GiftsApiClient'

export const TABLE_HEADERS: TableHeaders<GiveawayPackage> = [
  {
    id: 'giveaway',
    label: 'Giveaway',
    render: (giveawayPackage) => (
      <TableCell
        mainContent={
          <PhotoTableCellContent
            name={giveawayPackage.items[0]?.name}
            photo={giveawayPackage.items[0]?.image}
            photoSize="large"
          />
        }
      />
    ),
    width: 2,
  },
  {
    id: 'used',
    label: 'Used',
    render: (giveawayPackage) => (
      <TableCell
        mainContent={
          <>
            {giveawayPackage.stats.usage.redeemed} / {giveawayPackage.stats.usage.all}
          </>
        }
      />
    ),
    width: 0,
    minWidth: 150,
  },
]
